import React from "react";
import type { IconProps } from "types";

import variables from "../../styles/_variables.module.scss";

const AlertTriangle = ({ width = 15, height = 15, color = variables["dark-red"], className }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M6.43148 2.41226L1.13773 11.2498C1.02858 11.4388 0.970831 11.6531 0.97022 11.8713C0.969609 12.0896 1.02616 12.3042 1.13424 12.4938C1.24233 12.6835 1.39818 12.8415 1.58629 12.9522C1.77441 13.0629 1.98823 13.1224 2.20648 13.1248H12.794C13.0122 13.1224 13.226 13.0629 13.4142 12.9522C13.6023 12.8415 13.7581 12.6835 13.8662 12.4938C13.9743 12.3042 14.0308 12.0896 14.0302 11.8713C14.0296 11.6531 13.9719 11.4388 13.8627 11.2498L8.56898 2.41226C8.45756 2.22858 8.30068 2.07671 8.11347 1.97131C7.92627 1.86592 7.71506 1.81055 7.50023 1.81055C7.28539 1.81055 7.07418 1.86592 6.88698 1.97131C6.69978 2.07671 6.5429 2.22858 6.43148 2.41226V2.41226Z"
      stroke={color}
      strokeWidth="1.03448"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.5 5.625V8.125" stroke={color} strokeWidth="1.03448" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 10.625H7.5066" stroke={color} strokeWidth="1.03448" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default React.memo(AlertTriangle);
